import React, { useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FiSearch } from 'react-icons/fi';
import { FiPlus } from 'react-icons/fi';
import { FiEdit3 } from 'react-icons/fi';
import { PiPlusCircleFill } from 'react-icons/pi';
import { FaTimes } from 'react-icons/fa';
import BottomTab from '../components/BottomTab';
import { useNavigate } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import MoimDetailPage from './MoimDetailPage';
import LoadingOverlay from '../components/LoadingOverlay';
import MoimCreatePage from './MoimCreatePage';
import { findBookcommunityByHashtag } from '../api/BookcommunityApi';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;
const TopSection = styled.div`
  background: #eae8e9;
`;
const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #3e3e3e;
  margin: 12px 0 0 0;
  padding-left: 16px;
  margin-bottom: 12px;
  padding-bottom: 10px;
`;
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  margin: 0 20px 18px 20px;
  padding: 0 16px;
  height: 48px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  flex: 1;
  margin-left: 10px;
  &::placeholder {
    font-size: 14px;
    color: #bdbdbd;
  }
`;
const TabRow = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 0;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;
const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;
const SectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px 10px 20px;
  margin-top: 0;
`;
const SectionTitle = styled.div`
  font-size: 17px;
  font-weight: 400;
  color: #222;
  display: flex;
  align-items: center;
  gap: 6px;
`;
const SectionBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const MoimList = styled.div`
  margin: 0 20px 0 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;
const MoimItem = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 22px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;
const MoimThumb = styled.img`
  width: 120px;
  height: 80px;
  max-width: 120px;
  max-height: 80px;
  min-width: 120px;
  min-height: 80px;
  border-radius: 0;
  object-fit: cover;
  background: #eee;
  flex-shrink: 0;
`;
const MoimInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
`;
const MoimTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;
const MoimTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 0;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
`;
const MoimBadge = styled.div`
  background: ${({ children }) => {
    if (typeof children === 'string' && (children.includes('오프라인') || children.includes('온라인'))) return '#acacac';
    if (typeof children === 'string' && children.includes('필사단')) return '#d8a024';
    return '#1976d2';
  }};
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;
const MoimDesc = styled.div`
  font-size: 14px;
  color: #444;
  margin-bottom: 2px;
`;
const MoimSub = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 2px;
`;
const MoimTags = styled.div`
  font-size: 12px;
  color: #7d7d7d;
  margin-top: 2px;
  font-weight: 500;
`;
const ContentSection = styled.div`
  background: #fff;
  padding-bottom: 80px;
`;
const WhiteSpacer = styled.div`
  height: 20px;
  background: #fff;
`;
const GenreTagScroll = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  padding: 0 20px 16px 20px;
  margin-bottom: 4px;
  -webkit-overflow-scrolling: touch;
  
  /* 스크롤바 완전히 숨기기 */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Firefox에서 스크롤바 숨기기 */
  scrollbar-width: none;
  
  /* IE에서 스크롤바 숨기기 */
  -ms-overflow-style: none;
`;
const GenreTag = styled.button`
  display: inline-block;
  background: #245cd8;
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 13px;
  padding: 5px 14px;
  margin-right: 8px;
  margin-bottom: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  &:active {
    background: #1746a2;
  }
`;
/*
const moimList = [
  {
    thumb: '/book_sample.jpg',
    title: '가난의 문법',
    badge: '서평단 10명',
    desc: '수령 후 2주 안 서평, 우수리뷰어 커피',
    tags: '#소준철 #푸른숲 #사회 #우수컨텐츠',
  },
  {
    thumb: '/book_sample2.jpeg',
    title: '패신저, 파리',
    badge: '필사단 20명',
    desc: '수령 후 3주 안 필사, 도서증정',
    tags: '#인문 #여행 #Pensel #프랑스 #파리',
  },
  {
    thumb: '/book_sample3.jpeg',
    title: '나는 메트로폴리탄 ...',
    badge: '서평단 5명',
    desc: '20만 부 기념 양장 에디션',
    tags: '#에세이 #패트릭브링리 #웅진지식하우',
  },
];

const newMoimList = [
  {
    thumb: '/book_sample4.jpeg',
    title: '행복의 조건',
    badge: '필사단 8명',
    desc: '수령 후 2주 안 필사, 기프티콘 증정',
    tags: '#심리 #행복 #자기계발',
  },
  {
    thumb: '/book_sample5.jpeg',
    title: '미래의 나에게',
    badge: '서평단 12명',
    desc: '수령 후 3주 안 서평, 도서증정',
    tags: '#에세이 #미래 #성장',
  },
];

// 추천모임 샘플 데이터
const popularMoimList = [
  {
    thumb: '/book_sample6.jpeg',
    title: '아침독서모임',
    badge: '오프라인',
    desc: '매일 아침 7시, 오프라인 독서 습관 만들기',
    tags: '#습관 #아침 #오프라인',
  },
  {
    thumb: '/book_sample7.jpeg',
    title: '퇴근길 필사모임',
    badge: '온라인',
    desc: '퇴근 후 30분, 온라인 필사하며 하루 마무리',
    tags: '#필사 #퇴근 #온라인',
  },
];
const genreMoimList = [
  {
    thumb: '/book_sample8.jpeg',
    title: 'SF소설 읽기',
    badge: '오프라인',
    desc: '매주 토요일, 오프라인 SF소설 한 권 읽기',
    tags: '#SF #소설 #장르',
  },
  {
    thumb: '/book_sample9.jpeg',
    title: '에세이 나눔',
    badge: '온라인',
    desc: '에세이 추천과 감상 나누기 (온라인)',
    tags: '#에세이 #감상 #추천',
  },
];


// 신규모임 샘플 데이터
const newRecommendMoimList = [
  {
    thumb: '/book_sample10.jpeg',
    title: '클래식 독서회',
    badge: '오프라인',
    desc: '고전 문학 작품 함께 읽고 토론하기',
    tags: '#고전 #문학 #토론',
  },
  {
    thumb: '/book_sample11.jpeg',
    title: '비즈니스 북클럽',
    badge: '온라인',
    desc: '경영/비즈니스 도서로 인사이트 공유',
    tags: '#비즈니스 #경영 #인사이트',
  },
];
*/

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 20px 20px 20px;
`;

const ModalMoimList = styled.div`
  margin-top: 16px;
`;

const ModalMoimItem = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 22px;
  cursor: pointer;
  padding: 16px;
  border-radius: 8px;
  transition: background-color 0.2s;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  
  &:hover {
    background: #f8f9fa;
  }
`;

const ModalMoimThumb = styled.img`
  width: 120px;
  height: 80px;
  max-width: 120px;
  max-height: 80px;
  min-width: 120px;
  min-height: 80px;
  border-radius: 0;
  object-fit: cover;
  background: #eee;
  flex-shrink: 0;
`;

const ModalMoimInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
`;

const ModalMoimTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

const ModalMoimTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 0;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
`;

const ModalMoimBadge = styled.div`
  background: ${({ children }) => {
    if (typeof children === 'string' && (children.includes('오프라인') || children.includes('온라인'))) return '#acacac';
    if (typeof children === 'string' && children.includes('필사')) return '#d8a024';
    return '#1976d2';
  }};
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;

const ModalMoimDesc = styled.div`
  font-size: 14px;
  color: #444;
  margin-bottom: 2px;
`;

const ModalMoimTags = styled.div`
  font-size: 12px;
  color: #7d7d7d;
  margin-top: 2px;
  font-weight: 500;
`;

const LoadingText = styled.div`
  text-align: center;
  padding: 20px;
  color: #888;
  font-size: 14px;
`;


const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const EditCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;




const TESTEvent = () => {
  return (
    <Modal>
    <ModalTitle>TESTEvent</ModalTitle>
    </Modal>
  )
};
const CommunityDetailModal = ({ bookCommunityId, onClose }) => {
  const [isModified, setIsModified] = useState(false);
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>모임 상세</ModalTitle>
        <CloseButton onClick={()=>{onClose(isModified);}}>
          <FaTimes />
        </CloseButton>
      </ModalHeader>
      <ModalContent id="noobook-page-modal">
        <MoimDetailPage bookCommunityId={bookCommunityId} onModified={setIsModified} onClose={()=>{onClose(true);}} />
      </ModalContent>
    </Modal>
  )
};


const defaultGenreTags = ['#소설', '#인문', '#자기계발', '#과학', '#그림책', '#역사'];
const PAGE_SIZE = 20;

export function CommunityMoimSearchResultPage({ keyword }) {
  const [tab, setTab] = useState('review');
  const [searchKeyword, setSearchKeyword] = useState(keyword || '');
  const [searchedMoimList, setSearchedMoimList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isModified, setIsModified] = useState(false);
  
  
  //const [modalLoading, setModalLoading] = useState(false);
  const [hasMoreSearchedMoim, setHasMoreSearchedMoim] = useState(true);
  const [searchedMoimPage, setSearchedMoimPage] = useState(0);
  
  // 이벤트 상세 모달 관련 상태
  const [showCommunityDetailModal, setShowCommunityDetailModal] = useState(false);
  const [selectedBookCommunityId, setSelectedBookCommunityId] = useState(null);
  
  // 인기모임 목록 상태
  //const [popularMoimList, setPopularMoimList] = useState([]);

  const navigate = useNavigate();
  const { setShowBack } = useNoobookContext();
  
  // 초기 데이터 설정
  useEffect(() => {
    setSearchKeyword(keyword);
  }, [keyword]);

  useEffect(() => {
    loadSearchedMoimList(); 
  }, [searchKeyword]);

  useEffect(() => {
    if(isModified) {
      loadSearchedMoimList();
      setIsModified(false);
    }
  }, [isModified]);
  
  

  // 모달에서 마감임박 목록 로드
  const loadSearchedMoimList = useCallback(async (page = 0, append = false) => {
    if (loading || (!hasMoreSearchedMoim && page > 0)) return;

    console.log('loadSearchedMoimList', page,  keyword, searchKeyword);
    
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      const response = await findBookcommunityByHashtag(
        accessToken || '', 
        searchKeyword,
        null,
        null,
        page, 
        PAGE_SIZE
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newData = processedResponse.data || [];
        if (append) {
          setSearchedMoimList(prev => [...prev, ...newData]);
        } else {
          setSearchedMoimList(newData);
        }
        setHasMoreSearchedMoim(newData.length === PAGE_SIZE);
        setSearchedMoimPage(page);
      } else {
        console.error('검색 목록 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('검색 목록 로드 중 오류:', error);
    } finally {
      setLoading(false);
    }
  }, [keyword, searchKeyword, loading, hasMoreSearchedMoim]);


  

  // 모달에서 아이템 클릭 시 상세 모달 열기
  const handleBookCommunityItemClick = useCallback((bookCommunityId) => {
    setSelectedBookCommunityId(bookCommunityId);
    setShowCommunityDetailModal(true);
  }, []);

  // 상세 모달 닫기
  const closeCommunityDetailModal = (modified) => {
    setShowCommunityDetailModal(false);
    setSelectedBookCommunityId(null);
    if(modified) {
      setIsModified(true);
    }
  };

  // 무한 스크롤 핸들러
  const handleSearchedMoimScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMoreSearchedMoim && !loading) {
      loadSearchedMoimList(searchedMoimPage + 1, true);
    }
  }, [searchedMoimPage, hasMoreSearchedMoim, loading, loadSearchedMoimList]);


  const openEditModal = () => {
    setShowEditModal(true);
  };

  // 수정 모달 닫기
  const closeEditModal = (modified) => {
    setShowEditModal(false);
    if(modified) {
      setIsModified(true);
    }
  };

  // 뒤로가기 버튼으로 모달 닫기
  useEffect(() => {
    const handlePopState = (event) => {
      if (showCommunityDetailModal) {
        event.preventDefault();
        closeCommunityDetailModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showEditModal) {
        event.preventDefault();
        closeEditModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      }
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showCommunityDetailModal || showEditModal) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showCommunityDetailModal, showEditModal]);
      



  return (
    <PageWrapper>
      <ContentSection>
          <>
            <WhiteSpacer />
            <SectionRow>
              <SectionTitle>검색결과 </SectionTitle>
              <SectionBtn onClick={()=>/*navigate('/moim-create')*/openEditModal()}><FiEdit3 size={16} /> 모임 만들기</SectionBtn>
            </SectionRow>
            <MoimList onScroll={handleSearchedMoimScroll}>
              {searchedMoimList.map((item, i) => (
                <MoimItem key={i} onClick={() => /*navigate(`/moim-detail?id=${item.id}`)*/handleBookCommunityItemClick(item.id)} style={{cursor:'pointer'}}>
                  <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.title} />
                  <MoimInfo>
                    <MoimTitleRow>
                      <MoimTitle>{item.title}</MoimTitle>
                      <MoimBadge>{item.communityType === 'ONLINE' ? '온라인' : '오프라인'}</MoimBadge>
                      <MoimBadge>{item.activityType === 'BOOK_REVIEW' ? '독서' : '필사'}</MoimBadge>
                    </MoimTitleRow>
                    <MoimDesc>{item.briefIntroduction}</MoimDesc>
                    <MoimTags>
                      {item.hashtags && item.hashtags.length > 0 
                        ? item.hashtags.map(tag => `#${tag}`).join(' ')
                        : '#태그없음'
                      }
                    </MoimTags>
                  </MoimInfo>
                </MoimItem>
              ))}
              {!hasMoreSearchedMoim && searchedMoimList.length > 0 && (
                <LoadingText>모든 목록을 불러왔습니다.</LoadingText>
              )}
            </MoimList>
          </> 
      </ContentSection>

      {/* 이벤트 상세 모달 */}
      {showCommunityDetailModal && (
        <CommunityDetailModal 
          bookCommunityId={selectedBookCommunityId} 
          onClose={closeCommunityDetailModal}
        />
      )}
      
      {/* 로딩 오버레이 */}
      {loading && <LoadingOverlay />}
      {/* 수정 모달 */}
      {showEditModal && (
        <EditModal>
          <EditModalHeader>
            <EditModalTitle>모임 만들기</EditModalTitle>
            <CloseButton onClick={closeEditModal}>
              <FaTimes />
            </CloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimCreatePage editBookCommunityId={null} onClose={closeEditModal} />
          </EditModalContent>
        </EditModal>
      )}
    </PageWrapper>
  );
}

export default CommunityMoimSearchResultPage; 